import { type FC } from 'react';
import { Accordion, VStack } from '@direct-frontend/components';
import { type OpenApiSchemaDashboardTodolistItem } from '#shared/api/schema';
import {
    DashboardTodoListItem,
    type DashboardTodoListItemFeatureHintsConfig,
} from '#shared/components/DashboardTodoListItem';
import { DashboardTodoListAllCompletedBanner } from '../DashboardTodoListAllCompletedBanner/DashboardTodoListAllCompletedBanner';
import styles from './DashboardTodoListContentLayout.module.css';

export type DashboardTodoListContentLayoutProps = {
    completingItemId: string | null;
    itemsToComplete: OpenApiSchemaDashboardTodolistItem[];
    itemsCompleted: OpenApiSchemaDashboardTodolistItem[];
    openItemId: string | null;
    firstIncomplete: OpenApiSchemaDashboardTodolistItem | undefined;
    firstIncompleteFeatureHints: DashboardTodoListItemFeatureHintsConfig | undefined;
    makeExpandToggle: (itemId: string) => (nextExpanded: boolean) => void;
    onToggleItemComplete: (item: OpenApiSchemaDashboardTodolistItem) => void;
    onMarkdownLinkClick: (params: { itemId: string; href: string }) => void;
};

export const DashboardTodoListContentLayout: FC<DashboardTodoListContentLayoutProps> = ({
    completingItemId,
    itemsToComplete,
    itemsCompleted,
    openItemId,
    firstIncomplete,
    firstIncompleteFeatureHints,
    makeExpandToggle,
    onToggleItemComplete,
    onMarkdownLinkClick,
}) => (
    <>
        <VStack gap="8">
            {itemsToComplete.length === 0 ? <DashboardTodoListAllCompletedBanner /> : null}
            {itemsToComplete.map((item) => (
                <DashboardTodoListItem
                    key={item.id}
                    completingItemId={completingItemId}
                    data-testid={`DashboardTodoList.Item.${item.id}`}
                    expanded={openItemId === item.id}
                    featureHints={item.id === firstIncomplete?.id ? firstIncompleteFeatureHints : undefined}
                    item={item}
                    onExpandToggle={makeExpandToggle(item.id)}
                    onMarkdownLinkClick={(href) => onMarkdownLinkClick({ itemId: item.id, href })}
                    onToggleItemComplete={onToggleItemComplete}
                />
            ))}
        </VStack>
        {itemsCompleted.length > 0 ? (
            <VStack>
                <div className={styles.divider} />
                <Accordion
                    level="h4"
                    type="left"
                    data-testid="DashboardTodoList.CompletedSection"
                    title="Недавно выполненные"
                >
                    <VStack gap="8">
                        {itemsCompleted.map((item) => (
                            <DashboardTodoListItem
                                key={item.id}
                                completingItemId={completingItemId}
                                data-testid={`DashboardTodoList.Item.${item.id}`}
                                expanded={openItemId === item.id}
                                item={item}
                                onExpandToggle={makeExpandToggle(item.id)}
                                onMarkdownLinkClick={(href) => onMarkdownLinkClick({ itemId: item.id, href })}
                                onToggleItemComplete={onToggleItemComplete}
                            />
                        ))}
                    </VStack>
                </Accordion>
            </VStack>
        ) : null}
    </>
);
